export const firebaseConfig = {
  apiKey: "AIzaSyAz6ZzXQmahvVcEdNSma1FONiG4Rr20Euk",
  authDomain: "gemlogs-app.firebaseapp.com",
  projectId: "gemlogs-app",
  storageBucket: "gemlogs-app.appspot.com",
  messagingSenderId: "439913861495",
  appId: "1:439913861495:web:031dbf5ace3f85ee1a1172",
};

export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";
